import axios from "axios";

export default {
  state: {
    notifiche_info: [],
    foto_expiration_days: null,
  },
  getters: {
    get_notifiche_info: (state) => {
      return state.notifiche_info;
    },
    get_foto_expiration_days: (state) => {
      return state.foto_expiration_days;
    },
  },
  mutations: {
    set_notifiche_info(state, payload) {
      state.notifiche_info = payload;
    },
    remove_notifica_info(state, id_notifica) {
      let index = state.notifiche_info.findIndex((n) => n.id === id_notifica);
      if (index !== -1) {
        state.notifiche_info.splice(index, 1);
      }
    },
    update_notifica_info(state, payload) {
      let index = state.notifiche_info.findIndex((n) => n.id === payload.id);
      if (index !== -1) {
        state.notifiche_info.splice(index, 1, payload);
      }
    },
    set_foto_expiration_days(state, days) {
      state.foto_expiration_days = days;
    }
  },
  actions: {
    fetch_notifiche_info(context) {
      let url = process.env.VUE_APP_API_ROOT + "/admin/notif_info";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .get(url, { auth: auth })
          .then((response) => {
            context.commit("set_notifiche_info", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    archivia_notifica_info(context, id_notifica) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/notif_info/archivia/" +
        id_notifica;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, {}, { auth: auth })
          .then((response) => {
            context.commit("remove_notifica_info", id_notifica);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    elimina_foto_prodotto_bulk(context, payload) {
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/notif_info/elimina_foto_bulk";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, payload, { auth: auth })
          .then((response) => {
            resolve(response.data);
            context.commit("update_notifica_info", response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetch_foto_expiration_days(context) {
        let url = process.env.VUE_APP_API_ROOT + "/admin/notif_info/foto_expiration_days";
        let auth = context.getters.get_credential;
        return new Promise((resolve, reject) => {
          axios
            .get(url, { auth: auth })
            .then((response) => {
              resolve(response.data);
              context.commit("set_foto_expiration_days", response.data.days);
            })
            .catch((error) => {
              reject(error);
            });
        });
    },
    imposta_foto_expiration_days(context, days) {
        let url = process.env.VUE_APP_API_ROOT + "/admin/notif_info/imposta_foto_expiration_days";
        let auth = context.getters.get_credential;
        return new Promise((resolve, reject) => {
          axios
            .post(url, { days: days }, { auth: auth })
            .then((response) => {
              resolve(response.data);
              context.commit("set_foto_expiration_days", days);
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
    },
};
